<template>
    <div :style=" { left: this.lang === 'ar' ? 'unset' : '0', right: this.lang === 'ar' ? '0' : 'unset' }" class="card-content">
      <div :class="['close-btn-container justify-content-start px-5']">
        <img @click="close" class="close-btn " src="../../assets/icons/closeBtn.svg" />
      </div>
      <div  :class="lang === 'ar' ? 'right-dir no-left-border' : 'left-dir no-right-border'" id="user-profile">
        <div :class="[lang === 'ar' ? 'bold-ar' : 'bold-en', 'header']">
          <div class="white-border"></div>
          <div v-if="cardType === 'personal-card'" class="personal-card">
            <div class="titles">{{ $t('profile.userProfile')}}</div>
            <div class="action">
              <span @click="editProfile">{{ $t('profile.editProfile')}}</span>
              <img src="../../assets/icons/edit.svg" />
              <div class="edit-border"></div>
            </div>
          </div>
          <div v-if="cardType === 'recent-payments'" class="recent-payments">{{ $t('profile.recentPayments') }}</div>
        </div>
        <div v-if="cardType === 'personal-card'" class="personal-data">
          <div v-for="(item, i) in items" :key="i" class="personal-data-el">
            <div :class="[lang === 'ar' ? 'margin-ar' : 'margin-en', 'bullet']"></div>
            <span :class="lang === 'ar' ? 'bold-ar' : 'bold-en' ">{{ item.label }}</span>
            <span :class="lang === 'ar' ? 'regular-ar' : 'regular-en' "> {{ item.value }} </span>
          </div>
        </div>
        <div class="recent-payments-data" v-if="cardType === 'recent-payments'">
          <Loader v-if="loader" />
          <div v-if="!loader">
            <div v-for="(payment, i) in payments" :key="i" class="payment-data-el">
            <span>
              <div :class="[lang === 'ar' ? 'margin-ar' : 'margin-en']"></div>
              <span :class="[lang === 'ar' ? 'bold-ar' : 'bold-en',  'price']">{{ payment.amount }} {{ $t('Bundles.sp') }}</span>
            </span>
              <span :class="[lang === 'ar' ? 'regular-ar' : 'regular-en',  'date']"> {{ payment.date }} </span>
            </div>
          </div>
        </div>
        <button :disabled="loaderBtn" @click="handleExport" v-if="cardType === 'recent-payments'" :class="[lang === 'ar' ? 'bold-ar' : 'bold-en', 'btn']">
          <div v-if="loaderBtn" class="spinner-border text-danger text-center" role="status"></div>
          <div v-if="!loaderBtn">
            {{ $t('profile.export') }}
            <img src="../../assets/icons/none-fill-pdf.svg">
          </div>
        </button>
      </div>
    </div>
</template>
<script>
import RecentPaymentsRepository from '../../repositories/RecentPaymentsRepository'
import ProfileDataRepository from '../../repositories/ProfileDataRepository'
import PaymentsExport from '../../repositories/PaymentsExport'
import JobsRepository from '../../repositories/JobsRepository'
import Loader from '../../components/LoaderBtn/Loader'
import $ from 'jquery'
export default {
  components: { Loader },
  props: {
    show: Boolean,
    cardType: String,
    gsm: String
  },
  watch: {
    show (val) {
      if (this.cardType === 'recent-payments' && val) {
        this.fetchPayments()
      }
    }
  },
  created () {
    this.fetchJobs()
    if (this.cardType === 'recent-payments') {
      this.fetchPayments()
    } else if (this.cardType === 'personal-card') {
      const gsm = localStorage.getItem('gsm')
      setTimeout(() => {
        this.fetchProfile(gsm)
      })
    }
  },
  mounted () {
    setTimeout(() => {
      $('.card-content').css('bottom', '0')
    })
  },
  data () {
    return {
      lang: this.$lang,
      items: [
        { label: this.$t('profile.personalInfo.city'), value: '', key: 'city' },
        { label: this.$t('profile.personalInfo.gender'), value: '', key: 'gender' },
        { label: this.$t('profile.personalInfo.job'), value: '', key: 'jobId' },
        { label: this.$t('profile.personalInfo.email'), value: '', key: 'email' },
        { label: this.$t('profile.personalInfo.birth'), value: '', key: 'birthDate' },
        { label: this.$t('profile.personalInfo.address'), value: '', key: 'address' }
      ],
      loader: false,
      payments: [],
      jobs: [],
      recentPaymentsRepo: new RecentPaymentsRepository(),
      profileRepo: new ProfileDataRepository(),
      exportRepo: new PaymentsExport(),
      jobRepo: new JobsRepository(),
      loaderBtn: false
    }
  },
  methods: {
    editProfile () {
      this.$store.state.editProfile = true
      this.$emit('close')
    },
    async fetchJobs () {
      try {
        const response = await this.jobRepo.get()
        if (response.status === 200) {
          for (let i = 0; i < response.data.length; i++) {
            this.jobs.push({ label: response.data[i].name, value: response.data[i].id })
          }
        }
      } catch (e) {
      }
    },
    async handleExport () {
      try {
        this.loaderBtn = true
        const config = {
          params: { gsm: this.gsm },
          responseType: 'blob'
        }
        const response = await this.exportRepo.getWithParams(config)
        const a = document.createElement('a')
        const url = URL.createObjectURL(response)
        a.href = url
        a.download = 'recent-payments.pdf'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      } catch (e) {
        console.log(e)
      }
      this.loaderBtn = false
    },
    async fetchProfile (gsm) {
      try {
        const response = await this.profileRepo.get()
        for (let i = 0; i < this.items.length; i++) {
          for (const item in response.data) {
            if (this.items[i].key === item) {
              this.items[i].value = response.data[item]
              if (this.items[i].key === 'gender') {
                this.items[i].value = response.data[item] === 1 ? this.$t('genders.female') : this.$t('genders.male')
              }
            }
          }
        }
        for (let i = 0; i < this.jobs.length; i++) {
          if (this.items[2].value === this.jobs[i].value) {
            this.items[2].value = this.jobs[i].label
            return
          }
        }
        // console.log(this.items)
      } catch (e) {

      }
    },
    async fetchPayments () {
      try {
        this.loader = true
        const formData = new FormData()
        formData.append('gsm', this.gsm)
        const response = await this.recentPaymentsRepo.post(formData)
        if (response.data.status === 200) {
          this.payments = []
          for (let i = 0; i < response.data.data.length; i++) {
            this.payments.push(response.data.data[i])
          }
        }
      } catch (e) {
        console.log(e)
      }
      this.loader = false
    },
    close () {
      $('.card-content').css('bottom', '-100%')
      setTimeout(() => {
        this.$emit('close')
      }, 500)
    }
  }
}
</script>
<style lang="scss" scoped>
@import "src/assets/sass/main";
.no-right-border {
  border-right: none !important;
}
.no-left-border {
  border-left: none !important;
}
.card-content {
  width: 100%;
  position: fixed;
  height: calc(100vh - 110px);
  //overflow-y: auto;
  z-index: 1000;
  bottom: -100%;
  transition: all .5s ease-in-out;
}
.close-btn-container {
  height: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
}
#user-profile {
  background: linear-gradient(227deg, rgba(242,242,242,0.8), rgba(255,255,255,0.8));
  padding: 1rem .5rem;
  border-radius: 30px 30px 0 0;
  backdrop-filter: blur(20px);
  border: 2px solid rgba(255,255,255);
  height: 100%
  //min-height: 475px;
  //max-height: 635px
}
.header{
  border-bottom: 2px solid rgba(29,29,29, 0.3);
  padding: 0 1rem 10px 1rem;
  height: 85px;
  position: relative;
}
.header > .white-border {
  width: 100px;
  height: 3.5px;
  background: rgba(255,255,255,.8);
  position: absolute;
  transform: translateX(-50%);
  left: 50%;
  top: -6px;
  border-radius: 10px;
}
.personal-card{
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  height: 100%;
}
.personal-card > .titles {
  font-size: 18px
}
.personal-card > .action {
  color: $--yellow;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.personal-card > .action > span {
  text-decoration: underline;
  text-underline-offset: 2px;
}
.personal-card > .action > img {
  height: 15px;
  width: 15px;
  display: block;
  margin: 0 4px
}
.personal-card > .action > .edit-border {
  height: 2.5px;
  width: 12px;
  background: $--yellow;
  border-radius: 10px;
  align-self: flex-end;
  margin-bottom: 4px;
  margin-left: -9px
}
.personal-data {
  padding: 2rem .5rem;
}
.personal-data-el {
  margin-bottom: 2rem;
  display: flex;
  align-items: center;
  justify-content: initial;
}
.personal-data-el > span:last-child{
  max-width: 100%;
  word-break: break-all;
}
.personal-data-el:last-child {
  margin-bottom: 0
}
.personal-data-el > span:first-child {
  font-size: 17px
}
.bullet {
  height: 5px;
  width: 5px;
  border-radius: 50%;
  background: #1d1d1d
}
.margin-en{
  margin-right: 5px
}
.margin-ar{
  margin-left: 5px
}
//.personal-data,
.recent-payments-data {
  //overflow-y: auto;
  //height: 70%
  height: calc(100% - (85px + 55px + 95px));
  overflow-y: auto;
}
.recent-payments {
  display: flex;
  align-items: center;
  height: 100%;
  font-size: 20px
}
.recent-payments-data{
  padding: 1rem 1rem
}
.payment-data-el{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 0;
  border-bottom: 2px solid rgba(29,29,29,0.2)
}
.payment-data-el:last-child {
  border: none;
  padding-bottom: 0
}
.payment-data-el > span:first-child {
  display: flex;
  align-items: center;
}
.payment-data-el > span:first-child > div {
  height: 6px;
  width: 6px;
  background-color: $--yellow;
  border-radius: 50%
}
.price {
  color: $--yellow;
}
.btn {
  width: 92%;
  display: block;
  margin: 0 auto;
  background: linear-gradient(45deg, rgba(242,242,242,.5), rgba(255,255,255,0.5));
  backdrop-filter: blur(50px);
  height: 55px;
  border: 3px solid #FFFFFF;
  border-radius: 20px;
  color: rgb(255,87,62);
  text-decoration: underline;
  text-underline-offset: 2px;
  font-size: 14px;
  box-shadow: 10px 10px 20px rgba(0,0,0,0.02)
 }
.btn > div {
  with: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}
.btn > div > img {
  height: 25px;
  width: 25px;
  display: block;
  margin: 0 10px
}
.close-btn{
  height: 40px;
  width: 40px;
  margin-top: 25px;
  cursor: pointer;
}
/*---------------------- responsive -----------------------------*/
@media(max-width: 1400px) {
  .card-content {
    width: 100%
  }
}
@media (max-height: 650px) {
  .card-content {
    overflow-y: auto;
  }
  #user-profile {
    height: auto;
  }
}
/*---------------------------------------------------------------*/
</style>
